import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessagesSquare, Plus } from "lucide-react";
import client, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { SectionTitle, Loading, Card } from "../components/common";
import { AdSlot } from "../components/AdSlot";
import { toast } from "sonner";

export default function ForumPage() {
  const { user } = useAuth();
  const [boards, setBoards] = useState(null);
  useEffect(() => { client.get("/forum").then((r) => setBoards(r.data)); }, []);
  if (!boards) return <Loading />;
  return (
    <div data-testid="forum-page">
      <AdSlot id="community.forum_header" height={80} className="mb-6" />
      <SectionTitle kicker="Community">Forum</SectionTitle>
      <div className="grid sm:grid-cols-2 gap-4">
        {boards.map((b) => (
          <Link to={`/forum/${b.slug}`} key={b.slug} data-testid={`board-${b.slug}`}>
            <Card className="p-5 flex items-center gap-4 hover:-translate-y-1 transition-transform">
              <div className="w-12 h-12 rounded-sm bg-green text-gold flex items-center justify-center"><MessagesSquare /></div>
              <div className="flex-1">
                <div className="font-head font-bold text-green text-lg">{b.name}</div>
                <div className="text-xs text-ink/50">{b.thread_count} thread{b.thread_count === 1 ? "" : "s"}</div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
